
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getAvailableFilterOptions",
      resolverType: "query",
      routePath: "/getAvailableFilterOptions",
      httpMethod: "POST",
    });
  